import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { CallLog } from '@/models/callLog';

export const fetchLastCallLog = async (operatorId: string): Promise<CallLog | null> => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      operatorId,
    },
    query: graphql(`
      query lastCallLog($operatorId: String!) {
        lastCallLog(operatorId: $operatorId) {
          id
          fromPhoneNumber
          toPhoneNumber
          resolvedPhoneNumber
          callerId
          rideId
          operatorId
          isOnHold
          purpose
          isRegistrationCall
          isNoMembership
          registrationTransferNotes {
            title
            callNotes
            fromDepartment
            alreadyDiscussed
            notesForOperator
          }
        }
      }
    `),
  });

  return response.data.lastCallLog;
};
